import { render, staticRenderFns } from "./DisasterEventSend.vue?vue&type=template&id=771d9a33"
import script from "./DisasterEventSend.vue?vue&type=script&lang=js"
export * from "./DisasterEventSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports